import { StyleSheet, View } from 'react-native';

import { useStaticTranslation } from '../services/staticTranslations';
import { Paragraph, ParagraphSizes } from './paragraph';

const Copyright = (props) => {
  const style = props.style || {};
  const color = props.color ? { color: props.color } : {};
  return (
    <View style={[styles.copyrightView, style]}>
      <Paragraph size={ParagraphSizes.SMALL} style={color}>
        &copy; 2009-2020{' '}
        {useStaticTranslation(
          'Canadian Institute Of Natural And Integrative Medicine'
        )}
      </Paragraph>
    </View>
  );
};

const styles = StyleSheet.create({
  copyrightView: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  }
});

export { Copyright };
